import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import Nav from "@/components/Nav";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Access granted");
      nav("/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="grain min-h-screen bg-[#050505] text-white">
      <Nav />
      <div className="mx-auto grid min-h-[calc(100vh-73px)] max-w-7xl grid-cols-1 md:grid-cols-2">
        <div className="hidden flex-col justify-between border-r border-white/10 p-12 md:flex">
          <div>
            <div className="mb-4 h-8 w-8 rotate-45 border border-[#E5FF00] bg-[#E5FF00]/10"></div>
            <h2 className="font-display text-4xl font-medium tracking-tighter">Re-enter the vault.</h2>
            <p className="mt-4 max-w-md text-zinc-400">OBSIDIAN never sleeps. Sign in to review new exposures and continue takedowns already in flight.</p>
          </div>
          <pre className="font-mono text-[10px] leading-relaxed text-zinc-600">
{`> STATUS: OPERATIONAL
> UPTIME: 99.98%
> ACTIVE REMOVAL JOBS: 12,847
> CLIENTS PROTECTED: 4,921`}
          </pre>
        </div>

        <div className="flex flex-col justify-center p-8 md:p-12">
          <div className="mx-auto w-full max-w-sm">
            <div className="mb-2 font-mono text-[10px] uppercase tracking-[0.25em] text-[#E5FF00]">/ AUTH · SECURE CHANNEL</div>
            <h1 className="font-display text-3xl font-medium tracking-tight">Sign in</h1>
            <p className="mt-3 text-sm text-zinc-500">Enter your credentials to access the console.</p>

            <form onSubmit={submit} className="mt-10 space-y-6">
              <div>
                <Label htmlFor="email" className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-400">Email</Label>
                <Input data-testid="login-email" id="email" type="email" required value={email} onChange={e => setEmail(e.target.value)}
                  className="mt-2 rounded-none border-white/10 bg-black font-mono text-sm focus-visible:border-[#E5FF00] focus-visible:ring-0" />
              </div>
              <div>
                <Label htmlFor="pw" className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-400">Password</Label>
                <Input data-testid="login-password" id="pw" type="password" required value={password} onChange={e => setPassword(e.target.value)}
                  className="mt-2 rounded-none border-white/10 bg-black font-mono text-sm focus-visible:border-[#E5FF00] focus-visible:ring-0" />
              </div>
              <Button data-testid="login-submit" disabled={loading} type="submit"
                className="btn-cta h-12 w-full rounded-none border border-[#E5FF00] bg-[#E5FF00] font-mono text-[11px] uppercase tracking-[0.25em] text-black hover:bg-transparent hover:text-[#E5FF00]">
                {loading ? "Verifying…" : "Enter Console →"}
              </Button>
            </form>
            <p className="mt-8 font-mono text-[11px] text-zinc-500">
              No account? <Link data-testid="link-signup" to="/signup" className="text-[#E5FF00] hover:underline">Create one</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
